import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from '@/router/routes'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes
})

router.afterEach((to, from, next) => {
  if (!to.matched.some(record => record.meta.dontJumpToTop)) {
    setTimeout(() => {
      window.scrollTo(0, 0)

      let rightContent = document.getElementsByClassName('right');

      if (rightContent && rightContent[0]) {
        rightContent[0].scrollTo(0, 0)
      }
    }, 300);
  }
})

router.beforeEach((to, from, next) => {
  const _user = JSON.parse(localStorage.getItem("user") || '{}');

  if (!_user?.districts) {
    localStorage.clear();
  }

  const tokenIsValid = Vue.Helper.validateToken()

  if (to.matched.some(record => record.meta.requiresAuth)) { // Logged in user/admin only
    if (!tokenIsValid) {
      next({
        name: 'login',
        query: {
          returnUrl: to.fullPath
        }
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.guest)) { // Non user only. Eg: Auth pages
    if (!tokenIsValid) {
      next()
    } else {
      next({
        path: '/'
      })
    }
  } else {
    next()
  }
})

export default router